import dataTools from './data.js'
export default {
  getDefaultEccentricityThreshold() {
    return 1e-4
  },
  displayComputationWidget(dashboard) {
    return this.computationNeeded(dashboard) || !dashboard.resultLoaded
  },
  displayResult(dashboard) {
    return dashboard.resultLoaded && !this.computationNeeded(dashboard)
  },
  displayError(dashboard) {
    return (
      dashboard.currentResultsLog &&
      dashboard.currentResultsLog.errors &&
      dashboard.currentResultsLog.errors.length
    )
  },
  resultLoaded(dashboard) {
    return (
      dashboard.currentResultsLog != null &&
      dashboard.currentResultsLog.results != null
    )
  },
  computationNeeded(dashboard) {
    return (
      dashboard.currentMission &&
      dashboard.currentMission.computationRequested &&
      dashboard.currentMission.computationLogId === ''
    )
  },
  dataLoaded(dashboard) {
    if (dashboard.resultLoaded) {
      if (dashboard.currentResultsLog.errors.length === 0) {
        return true // no error
      }
    }
    return false
  },
  displayWarningEccentricity(dashboard) {
    let tolerance = this.getDefaultEccentricityThreshold()
    let targetEcc = this.getTargetEccentricity(dashboard)
    let finalEcc =
      dashboard.currentResultsLog?.results?.finalOrbit?.eccentricity

    return Math.abs(finalEcc - targetEcc) >= tolerance
  },
  warningEccentricityMessage(dashboard) {
    let targetEcc = this.getTargetEccentricity(dashboard)
    let formattedFinalEcc =
      Math.round(
        dashboard.currentResultsLog?.results?.finalOrbit?.eccentricity * 1e6
      ) / 1e6
    let message =
      'Disclaimer: the target eccentricity could not be met with precision. Target eccentricity: ' +
      targetEcc +
      ' / final eccentricity obtained: ' +
      formattedFinalEcc +
      '. Please let us know if the final orbit does not match your expectation during a mission. We will investigate and fix it.'

    let initialEcc = dashboard.currentMission.initialOrbit.eccentricity
    let tolerance = this.getDefaultEccentricityThreshold()
    if (Math.abs(targetEcc - initialEcc) <= tolerance) {
      message +=
        ' Note: it might help to add a small eccentricity change in the mission definition, for example ±' +
        5 * tolerance
    }
    return message
  },
  getTargetEccentricity(dashboard) {
    let missionDefinition = dashboard.currentMission

    if (missionDefinition.targetOrbit) {
      return missionDefinition.targetOrbit.eccentricity
    } else {
      let initialEcc = missionDefinition.initialOrbit.eccentricity
      return initialEcc + missionDefinition.deltaEccentricity
    }
  },
  resetLayout(dashboard) {
    let mission = dataTools.saveGridLayout(
      dashboard.currentMission,
      [],
      dashboard.defaultLayout
    )
    dashboard.$http
      .put(
        this.getCurrentAPI(dashboard) + '/' + mission.id + '/minorupdate',
        mission
      )
      .then((response) => {
        dashboard.$root.$emit('set-current-mission', response.data)
      })
  },
  saveLayout(dashboard) {
    if (dashboard != null) {

      let mission = dataTools.saveGridLayout(
        dashboard.currentMission,
        dashboard.configurations,
        dashboard.gridlayout
      )
      dashboard.$http
        .put(
          this.getCurrentAPI(dashboard) + '/' + mission.id + '/minorupdate',
          mission
        )
        .then((response) => {
          dashboard.$root.$emit('set-current-mission', response.data)
        })
    }
  },
  removeDuplicatedGridItem(dashboard) {
    // remove duplicated items (same id
    for (let i = 0; i < dashboard.configurations.length - 1; i++) {
      // remove configurations
      if (
        dashboard.configurations[i].gridItem.i ===
        dashboard.configurations[i + 1].gridItem.i
      ) {
        // same id
        dashboard.configurations.splice(i + 1, 1) // remove the others
      }
    }
    if (dashboard.gridlayout) {
      for (let i = 0; i < dashboard.gridlayout.length - 1; i++) {
        // first remove duplicated ids
        if (dashboard.gridlayout[i].i === dashboard.gridlayout[i + 1].i) {
          // same id
          dashboard.gridlayout.splice(i + 1, 1) // remove the others
        }
      }
      // remove ghosts : in the layout but no configuration
      for (let i = 0; i < dashboard.gridlayout.length; i++) {
        let itemId = dashboard.gridlayout[i].i
        if (itemId.startsWith('plot')) {
          let configuration = dashboard.configurations.find(
            (el) => el.gridItem.i === itemId
          )
          if (configuration == null) {
            dashboard.gridlayout.splice(i, 1)
            i = i - 1 // because i should not be increased
          }
        }
      }
    }
  },
  statsCardResized(dashboard, i) {
    let card = dashboard.$refs[`${dashboard.statsCardName}${i}`]
    if (card != null) {
      card.updateCardWidth()
    }
  },
  editPlotConfiguration(dashboard, index) {
    dashboard.configuration = dashboard.configurations[index]
    dashboard.$refs.plotConfig.drawer = true
    let plotingArea = document.getElementById(
      `${dashboard.plotingAreaName}${dashboard.configuration.gridItem.i}`
    )
    if (plotingArea != null) {
      dashboard.$root.$emit(
        'set-plot-config',
        dashboard.configuration,
        plotingArea
      )
    }
  },
  removePlotConfiguration(dashboard, gridIndex) {
    let index = dashboard.configurations.findIndex((el) => {
      return el.gridItem.i === gridIndex
    })
    let currentConfig = dashboard.configurations[index]
    let plotingArea = document.getElementById(
      `${dashboard.plotingAreaName}${currentConfig.gridItem.i}`
    )
    if (plotingArea != null) {
      try {
        Plotly.purge(plotingArea)
      } catch (e) {}
    }
    dashboard.configuration = undefined
    dashboard.isDrawn.splice(index, 1)
    dashboard.configurations.splice(index, 1)
    dashboard.gridlayout = dashboard.gridlayout.filter(
      (el) => el.i !== gridIndex
    )
  },
  getResultUnitLabel(dashboard, fieldPath) {
    let fieldType = dataTools.getFieldTypeFromPath(
      fieldPath,
      dashboard.type,
      null
    )
    return (
      ' ' + dataTools.getUnitDisplayed(dataTools.getDefaultGuiUnit(fieldType))
    )
  },

  getMissionItem(mission) {
    if (mission && mission.constructor === Array) {
      return mission[0]
    } else {
      return mission
    }
  },
  getCurrentAPI(dashboard) {
    if (dashboard.currentMission) {
      if (dashboard.currentMission.type === 'Formation flying') {
        return this.getAPI(dashboard, 'formationflyingsimulationrequests')
      } else if (dashboard.currentMission.type === 'Inspection mission') {
        return this.getAPI(dashboard, 'inspectionsimulationrequests')
      }
      return this.getAPI(dashboard, dashboard.currentMission.typeName + 's')
    }
  },
  getAPI(dashboard, objectAPI) {
    return '/users/' + dashboard.currentUser.id + '/' + objectAPI.toLowerCase()
  },

  isOrbitExtrapolationMission(mission) {
    return this.isMissionType(mission, 'Orbit Extrapolation')
  },

  isManeuveringStrategyDesignMission(mission) {
    return this.isMissionType(mission, 'Maneuvering Strategy Design')
  },

  isSimulatorMission(mission) {
    return this.isMissionType(mission, 'Simulator')
  },

  isPositioningMission(mission) {
    return this.isMissionType(mission, 'Orbital Transfer')
  },

  isADCSMission(mission) {
    return this.isMissionType(mission, 'ADCS Design')
  },

  isArgumentOfLatitudePhasingMission(mission) {
    return this.isMissionType(mission, 'Orbit Phasing')
  },

  isStationKeepingLEOMission(mission) {
    return this.isMissionType(mission, 'LEO Station Keeping')
  },

  isDeorbitingMission(mission) {
    return this.isMissionType(mission, 'Deorbitation')
  },

  isRAANMission(mission) {
    return this.isMissionType(mission, 'RAAN Phasing')
  },

  isSequenceMission(mission) {
    return this.isMissionType(mission, 'Sequence')
  },

  isMissionType(mission, type) {
    let firstMission = this.getMissionItem(mission)
    if (firstMission == null) {
      return false
    }
    return firstMission.type === type
  }
}
